<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">婴幼儿语言量表统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span
            class="name">语言</span></div>
      </div>
      <div class="body">
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol"
                      :wrapper-col="wrapperCol" labelAlign="left">
          <div v-if="detailScoreAvailable || existingDetailed" class="detail-score-switch">
            <div>
              <div class="detail-score-switch-title">详细分数录入</div>
              <div class="detail-score-switch-state">{{ detailScoreMode ? '已开启' : '手工录入' }}</div>
            </div>
            <a-switch
              :checked="detailScoreMode"
              :disabled="existingDetailed && !detailScoreAvailable"
              @change="handleDetailScoreModeChange"
            />
          </div>
          <bayley-score-detail
            v-if="detailScoreMode"
            v-model="formModel.simple.detail_scores"
            @totals-change="applyDetailTotals"
          />
          <a-row>
            <a-col :span="11">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="语言-接受性沟通(RC)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_rc" :disabled="detailScoreMode"
                                      class="cu-input1 input-number-100" :min="0" :max="84"/>
                      <span class="num-de"><0-84></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="语言-表达性沟通(EC)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_ec" :disabled="detailScoreMode"
                                      class="cu-input1 input-number-100" :min="0" :max="74"/>
                      <span class="num-de"><0-74></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="显著性水平">
                    <a-select v-model="formModel.simple.significance_level" placeholder="请选择"
                              style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="0.10">0.10</a-select-option>
                      <a-select-option value="0.05">0.05</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="置信区间" prop="simple.confidence_probability">
                    <a-select v-model="formModel.simple.confidence_probability" placeholder="请选择"
                              style="width: 260px;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">行为观察清单：</p>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">积极影响:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex1">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk1">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">热情:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex2">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk2">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">探索:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex3">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk3">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">容易投入:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex4">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk4">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">合作性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex5">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk5">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">适度活跃:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex6">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk6">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">对改变的适应性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex7">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk7">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">警觉性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex8">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk8">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">注意力分散:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex9">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk9">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">动作张力:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex10">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk10">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">触觉防御:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex11">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk11">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">恐惧/焦虑:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex12">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk12">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">消极影响:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex13">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk13">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <div style="border-bottom: 1px solid #f8f8f8;margin: 40px 0">&nbsp;</div>

          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center">
            <!--            <div class="btn sh" @click="goSelectAge"><img src="/images/btn-left-icon.png" alt="" style="height: 12px;margin-right: 5px"><span>返回选择页面</span></div>-->
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>

          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import {Save, Detail, Update, GetDetailScoreFeature} from '../../commonApi';
import BayleyScoreDetail from '../../components/bayley-score-detail';
import {base, simple, simpleRule} from "../simple-field";
import {message} from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";

export default {
  components: { BayleyScoreDetail },
  data() {
    return {
      scoreCdTip: '<0-119>',
      scoreCdMax: 119,
      scoreBDBool: false,
      scoreCOBool: false,
      scoreDSBool: false,
      labelCol: {span: 8, style: {color: '#7E8589', fontWeight: '500'}},
      wrapperCol: {span: 14},
      formModel: {
        base: Object.assign({}, base),
        simple: Object.assign({}, simple),
      },
      formRules: Object.assign({
        "simple.score_cg": [
          {required: true, message: '请输入认知(CG)分数', trigger: 'change'},
        ],
        "simple.score_rc": [
          {required: true, message: '请输入语言-接受性沟通(RC)分数', trigger: 'change'},
        ],
        "simple.score_ec": [
          {required: true, message: '请输入语言-表达性沟通(EC)分数', trigger: 'change'},
        ],
        "simple.score_fm": [
          {required: true, message: '请输入动作-精细动作(FM)分数', trigger: 'change'},
        ],
        "simple.score_gm": [
          {required: true, message: '请输入动作-粗大动作(GM)', trigger: 'change'},
        ],
        "simple.significance_level": [
          {required: true, message: '请选择显著性水平', trigger: 'change'},
        ],
        "simple.confidence_probability": [
          {required: true, message: '请选择置信区间', trigger: 'change'},
        ],
      }, {...simpleRule}),
      isUnit: 1, // 是否关联
      bindListVisible: false,
      detailScoreAvailable: false,
      detailScoreMode: false,
      existingDetailed: false,
      id: ''
    }
  },
  mounted() {
    this.loadDetailScoreFeature();

    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
    if (this.$route.query && this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    this.scoreBDBool = false
    this.scoreCOBool = false
    this.scoreDSBool = false
    if (this.formModel.simple.simple_sub_test_num === 4) {
      this.formModel.simple.score_bd = null;
      this.formModel.simple.score_co = null;
      this.scoreBDBool = true
      this.scoreCOBool = true
    } else if (this.formModel.simple.simple_sub_test_num === 5) {
      this.formModel.simple.score_ds = null;
      this.scoreDSBool = true;
    }
  },
  methods: {
    async loadDetailScoreFeature() {
      const res = await GetDetailScoreFeature();
      if (res && res.code == 0) this.detailScoreAvailable = Boolean(res.enabled);
    },
    handleDetailScoreModeChange(checked) {
      this.detailScoreMode = checked;
      this.formModel.simple.detail_score_enabled = checked ? '1' : '0';
    },
    applyDetailTotals(totals) {
      if (!this.detailScoreMode) return;
      Object.keys(totals).forEach((key) => this.$set(this.formModel.simple, key, totals[key]));
    },
    changeHx() {
      // if (/^[0-9]+$/.test(this.formModel.simple.score_car) && /^[0-9]+$/.test(this.formModel.simple.score_cas)) {
      //   this.formModel.simple.score_ca = parseInt(this.formModel.simple.score_car) + parseInt(this.formModel.simple.score_cas)
      // } else {
      //   this.formModel.simple.score_ca = '';
      // }
    },
    handleRadio() {
      this.scoreBDBool = false
      this.scoreCOBool = false
      this.scoreDSBool = false
      if (this.formModel.simple.simple_sub_test_num === 4) {
        this.formModel.simple.score_bd = null;
        this.formModel.simple.score_co = null;
        this.scoreBDBool = true
        this.scoreCOBool = true
      } else if (this.formModel.simple.simple_sub_test_num === 5) {
        this.formModel.simple.score_ds = null;
        this.scoreDSBool = true;
      }
    },

    async getDetail() {
      const res = await Detail({id: this.id});
      if (res && res.code == 0) {
        const detailScoreMode = String(res.bayleyAssessment.detail_score_enabled) === '1';
        this.detailScoreMode = detailScoreMode;
        this.existingDetailed = detailScoreMode;
        this.formModel.simple = Object.assign({}, simple, res.bayleyAssessment, {
          detail_scores: res.bayleyAssessment.detail_scores || {},
        });
        this.formModel.base = {
          id: res.bayleyAssessment.id,
          name: res.bayleyAssessment.name,
          scoring_num: res.bayleyAssessment.scoring_num,
          gender: res.bayleyAssessment.gender,
          test_date: res.bayleyAssessment.test_date,
          born_date: res.bayleyAssessment.born_date,
          real_age: res.bayleyAssessment.real_age,
          is_premature_infant: res.bayleyAssessment.is_premature_infant,
          expected_date: res.bayleyAssessment.expected_date,
          adjustment_age: res.bayleyAssessment.adjustment_age,
          examiner_name: res.bayleyAssessment.examiner_name,
          caregivers_name: res.bayleyAssessment.caregivers_name,
          relationship_of_child: res.bayleyAssessment.relationship_of_child,
          relationship_remark: res.bayleyAssessment.relationship_remark,
          referral_remark: res.bayleyAssessment.referral_remark,
        }
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatToYMD(dateStr) {
      // 分割日期和时间
      const datePart = dateStr.split('T')[0];
      return datePart;
    },
    async actionData() {
      this.formModel.simple.detail_score_enabled = this.detailScoreMode ? '1' : '0';
      // this.changeComputingMethod()
      // if (!this.formModel.simple.score_bd) {
      //   if (this.formModel.simple.score_bd != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      // if (!this.formModel.simple.score_in) {
      //   if (this.formModel.simple.score_in != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      // if (!this.formModel.simple.score_mr) {
      //   if (this.formModel.simple.score_mr != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      // if (!this.formModel.simple.score_bs) {
      //   if (this.formModel.simple.score_bs != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      //
      // if (!this.formModel.simple.score_pm) {
      //   if (this.formModel.simple.score_pm != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      // if (!this.formModel.simple.score_si) {
      //   if (this.formModel.simple.score_si != '0') {
      //     this.formRules['simple.computing_method'][0]['required'] = true;
      //   }
      // }
      // if (!this.formModel.simple.score_bs) {
      //   if (this.formModel.simple.score_bs != '0') {
      //     if (this.formModel.simple.computing_method == 1) {
      //       this.formRules['simple.supplement_type'][0]['required'] = true;
      //     } else if (this.formModel.simple.computing_method == 2) {
      //       this.formRules['simple.supplement_type'][0]['required'] = false;
      //       this.$refs["form"].clearValidate('simple.supplement_type');
      //       this.formModel.simple.supplement_type = '';
      //     }
      //   }
      // }

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = null;
          if (this.formModel.base.born_date) {
            this.formModel.base.born_date = this.formatToYMD(this.formModel.base.born_date);
          }
          if (this.formModel.base.test_date) {
            this.formModel.base.test_date = this.formatToYMD(this.formModel.base.test_date);
          }
          if (this.formModel.base.expected_date) {
            this.formModel.base.expected_date = this.formatToYMD(this.formModel.base.expected_date);
          }
          if (this.id) {
            res = await Update({base: this.formModel.base, assessment: this.formModel.simple});
          } else {
            res = await Save({base: this.formModel.base, assessment: this.formModel.simple});
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({content: res.message});
            setTimeout(() => {
              if (this.id == '') {
                this.$router.push({path: "/"});
              } else if (this.id != '' && this.source == 'index') {
                this.$router.push({path: "/"});
                console.log(1)
              } else if (this.id != '' && this.source == 'history') {
                this.$router.push({path: "/maintain-history-report"});
              }

            }, 1500);
          }
        } else {
          message.error({content: '表单验证未通过'});
        }
      });
    }

  }
};
</script>
<style></style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* height: 460px; border-left: 1px solid #eee; */
  padding-left: 70px;
  justify-content: center;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #1aa197;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #1aa197;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}

.btn.sh {
  border: 1px solid #1aa197;
  border-radius: 5px;
  font-weight: 400;
  color: #1aa197;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>

<style scoped>
.detail-score-switch {
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 24px;
  padding: 0 22px;
  border-left: 4px solid #1aa197;
  background: #f4fafa;
}

.detail-score-switch-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.detail-score-switch-state {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
}
</style>
